module.exports = __webpack_public_path__ + "static/media/wallstation.03c4a627.png";